module.exports = __webpack_public_path__ + "img/button_backtomap-Text.4e6fe9dd.svg";